<div *ngIf="(comment == null || comment.length == 0)" class="upload-container" (click)="viewComment()" title="Add Comment">
    <i class="material-icons upload-container__icon">
      message
    </i>
  </div>
  <span class="comment" title="{{comment}}" *ngIf="comment != null && comment.length > 0" (click)="viewComment()">{{comment | slice:0:20}}{{comment.length > 20 ? '...' : ''}}</span>


  